/**
 * Flow Optimizer — RuleNode discriminant guards
 * For Media Devoted | Created By Ciro Autiero
 *
 * Pure guards for the widened `RuleNode` union (numeric `condition`, score
 * `ranking`, flow `tag`). Kept in a sibling of `voluum-flow-optimizer.types.ts`
 * (which re-exports them) so the large types module carries no runtime helpers
 * and each guard stays a single logical unit.
 */

import type { RuleNode } from './voluum-flow-optimizer.types';

/** True for a SCORE-RANKING condition node (`{ kind: 'ranking', … }`). */
export function isRankingNode(
  node: RuleNode,
): node is Extract<RuleNode, { kind: 'ranking' }> {
  return node.kind === 'ranking';
}

/** True for a FLOW-TAG membership condition node (`{ kind: 'tag', … }`). */
export function isTagNode(
  node: RuleNode,
): node is Extract<RuleNode, { kind: 'tag' }> {
  return node.kind === 'tag';
}
